import React from 'react'
import { useWeb3React } from '@web3-react/core'
import { Box, Flex, Heading, ButtonMenu, ButtonMenuItem } from 'uikit'
import useLocalDispatch from 'contexts/LocalRedux/useLocalDispatch'
import { HistoryFilter } from 'state/types'
import { setHistoryFilter, setHistoryPaneState } from 'state/predictions'
import { useGetHistoryFilter, useGetIsFetchingHistory } from 'state/predictions/hooks'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import Tabs, { TabPane } from 'rc-tabs'

import 'rc-tabs/assets/index.css'

// const Filter = styled.label`
//   align-items: center;
//   cursor: pointer;
//   display: inline-flex;
//   margin-right: 16px;
// `

const StyledHeader = styled(Box)`
  background: white;
  flex: none;
  padding: 38px 24px 0px;
`

const ImgClose = styled.img`
  width: 24px;
  height: 24px;
  cursor: pointer;
`

const ButtonMenuContainer = styled.div`
  margin-bottom: 40px;
  width: 100%;
  & > div {
    width: 100%;
  }

  & button {
    width: 100%;
  }
`

const TabLine = styled.div`
  background: #d9d9d9;
  height: 1px;
  width: 100%;
  margin-top: -1px;
`

interface HeaderProps {
  activeTab: HistoryTabs
  setActiveTab: (value: HistoryTabs) => void
}

export enum HistoryTabs {
  ROUNDS,
  PNL,
}

const Header: React.FC<HeaderProps> = ({ activeTab, setActiveTab }) => {
  const historyFilter = useGetHistoryFilter()
  const isFetchingHistory = useGetIsFetchingHistory()
  const { t } = useTranslation()
  const dispatch = useLocalDispatch()
  const { account } = useWeb3React()

  const handleClick = () => {
    dispatch(setHistoryPaneState(false))
  }

  const handleChange = (newFilter: HistoryFilter) => async () => {
    if (newFilter !== historyFilter) {
      dispatch(setHistoryFilter(newFilter))
    }
  }

  const switchTab = async (tabIndex: number) => {
    setActiveTab(tabIndex)
    await handleChange(HistoryFilter.ALL)()
  }

  return (
    <StyledHeader>
      <Flex alignItems="center" justifyContent="space-between" mb="24px">
        <Heading as="h3" size="md">
          {t('PREDICTION_82')}
        </Heading>
        <ImgClose onClick={handleClick} src={require('assets/images/prediction/close.svg').default} />
      </Flex>
      <ButtonMenuContainer>
        <ButtonMenu
          activeIndex={activeTab}
          scale="sm"
          // variant="subtle"
          styles={{ height: '40px', borderRadius: '22px', background: '#F3F3F3' }}
          onItemClick={switchTab}
        >
          <ButtonMenuItem>{t('PREDICTION_83')}</ButtonMenuItem>
          <ButtonMenuItem>{t('PNL')}</ButtonMenuItem>
        </ButtonMenu>
      </ButtonMenuContainer>
      {activeTab === HistoryTabs.ROUNDS && (
        <>
          <Tabs
            defaultActiveKey={HistoryFilter.ALL}
            onChange={(key: any) => {
              if (isFetchingHistory || !account) {
                return
              }
              if (key !== historyFilter) {
                dispatch(setHistoryFilter(key))
              }
            }}
          >
            <TabPane tab={t('PREDICTION_84')} key={HistoryFilter.ALL} />
            <TabPane tab={t('PREDICTION_85')} key={HistoryFilter.COLLECTED} />
            <TabPane tab={t('PREDICTION_86')} key={HistoryFilter.UNCOLLECTED} />
          </Tabs>
          <TabLine />
        </>
      )}
    </StyledHeader>
  )
}

export default Header
